export enum DecisionType {
  None,
  Approve,
  Decline
}
